export default "__VITE_ASSET__D3r0XKiz__"